export default __webpack_public_path__ + "295aa9cd2de6eb08e34b7ed0335c3b65.jpg";